import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { createWebHistory, createRouter } from 'vue-router'
import { initWatchdog } from '@nineapes/watchdog'

initWatchdog({
  endpoint: 'https://dev.nineapes.com/api/v1/rum/events',
  sessionRecordingEndpoint: 'https://dev.nineapes.com/api/v1/rum/events',
  userId: '123',
  apiKey: '123-pokedex-csr',
  projectId: '123-pokedex-csr'
})



const HomeView = () => import('./views/HomeView.vue')
const PokemonView = () => import('./views/PokemonView.vue')
const AboutView = () => import('./views/AboutView.vue')
const AboutPokemonView = () => import('./views/AboutPokemonView.vue')
const ErrorTestView = () => import('./views/ErrorTestView.vue')


const routes = [
    { path: '/', component: HomeView },
    { path: '/pokemon/:id', component: PokemonView },
    { path: '/about', component: AboutView },
    { path: '/about-pokemon', component: AboutPokemonView },
    { path: '/error-test', component: ErrorTestView }
  ]

const router = createRouter({
  history: createWebHistory(),
  routes
})

createApp(App).use(router).mount('#app')
